import React, { lazy } from "react";
import queryString from "query-string";
import PrivateRoute from "PrivateRoutes";

const Guardrails = lazy(() =>
  import(
    /* webpackChunkName: "Guardrails" */ "./components/Guardrails"
  )
);
const GuardrailsAddEdit = lazy(() =>
  import(
    /* webpackChunkName: "GuardrailsAddEdit" */ "./components/GuardrailsAddEdit"
  )
);

const createForm = ({ location }) => {
  const queryParams = queryString.parse(location.search);
  return <GuardrailsAddEdit mode="create" type={queryParams.type} />;
};

const editForm = ({ match }) => {
  return (
    <GuardrailsAddEdit mode="edit" guardrailsId={match.params._id} />
  );
};

const routes = () => {
  return (
    <React.Fragment>
      <PrivateRoute
        key="/settings/guardrails"
        exact={true}
        path="/settings/guardrails"
        component={Guardrails}
      />

      <PrivateRoute
        key="/settings/guardrails/create"
        exact={true}
        path="/settings/guardrails/create"
        component={createForm}
      />

      <PrivateRoute
        key="/settings/guardrails/edit/:_id"
        exact={true}
        path="/settings/guardrails/edit/:_id"
        component={editForm}
      />
    </React.Fragment>
  );
};

export default routes;


// WEBPACK FOOTER //
// src/modules/screens/settings/Guardrails/routes.js